<template>
<div class="view map active">
    <div class="view-container" :id="'map_container_'+id"></div>
    <div class="btn-fixed btn-position active" :class="{ 'loading' : loadingPosition }" @click="triggerSetCurrentLocation()"></div>
</div>
</template>

<script>
import { throttle, debounce } from 'lodash'
import { mapStores, mapState } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'
import uniqid from 'uniqid'

export default {
    data () {
        return {
            map: null,
            markers: [],
            mapType: 'hybrid',
            loadingPosition: false,
            id: uniqid()
        }
    },
    mounted () {
        this.init()
    },
    computed: {
        ...mapStores(useBookingStore),
        ...mapState(useBookingStore, {
            clinics: state => state.clinics,
            bounds: state => state.bounds,
            boundsTypes: state => state.boundsTypes,
            productArea: state => state.productArea,
            zoom: state => state.zoom,
            singleResultClinic: state => state.singleResultClinic
        })
    },
    watch: {
        clinics () {
            console.log('clinics watcher updated')
            this.setMarkers()
        },
        productArea () {
            console.log('productArea watcher updated')
            this.resetMarkers()
            this.fetch(true)
        },
        bounds () {
            console.log('bounds watcher updated')

            const mapBounds = new google.maps.LatLngBounds()

            this.bounds.forEach(bound => {
                mapBounds.extend(bound)
            })

            this.map.fitBounds(mapBounds)

            if(this.bookingStore.hasSearch == 'address'){

                var current_zoom = this.map.getZoom()

                if (this.boundsTypes.indexOf('administrative_area_level_2') !== -1 || this.boundsTypes.indexOf('administrative_area_level_1') !== -1) {
                    
                    if(this.bookingStore.autocompleteSelectedPhrase == "Göteborg"){
                        this.map.setCenter({ lat: 57.7051699, lng: 11.9402128 })
                        current_zoom = current_zoom+3;
                    }else if(this.bookingStore.autocompleteSelectedPhrase == "Stockholms län" || this.bookingStore.autocompleteSelectedPhrase == "Stockholm"){
                        this.map.setCenter({ lat: 59.3038711, lng: 18.0861552 })
                        current_zoom = current_zoom+3;
                    }else if(this.bookingStore.autocompleteSelectedPhrase == "Malmö"){
                        this.map.setCenter({ lat: 55.5938666, lng: 13.000192 })
                        current_zoom = current_zoom+3;
                    }else{
                        current_zoom = current_zoom+2;
                    }                    

                }else{
                    current_zoom = current_zoom-1;
                }

                this.map.setZoom(current_zoom)
            }

            this.bookingStore.boundsFromAddress = []            

        },
        singleResultClinic: {
            handler (val) {
                this.resetMarkers()
                this.fetch(true)

                if (this.singleResultClinic) {
                    this.map.setCenter(this.singleResultClinic._geo)
                    this.map.setZoom(16)
                }
            },
            deep: true
        },
        '$route' (to, from) {
            if (to.name === 'booking' && from.name !== 'modal-clinic' && from.name !== 'modal-address') {
                this.setMarkers(true)
            }
        }
    },
    methods: {
        async init () {
            const [{ AdvancedMarkerElement }] = await Promise.all([
                google.maps.importLibrary('marker'),
                google.maps.importLibrary('maps')
            ])

            this.map = new google.maps.Map(document.getElementById('map_container_' + this.id), {
                center: { lat: 61.1740832, lng: 15.2460806 },
                zoom: this.zoom,
                minZoom: 4,
                mapTypeId: this.mapType,
                disableDefaultUI: true,
                zoomControl: false,
                scaleControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                gestureHandling: 'greedy',
                mapId: 'f98e1e78919c6a51'
            })

            this.map.addListener('bounds_changed', throttle(() => {
                this.fetch()
                this.bookingStore.trigTimeHighlight = true
            }, 200))

            // Ensures the final settled viewport is applied after a pan/zoom ends
            this.map.addListener('idle', () => {
                this.fetch()
            })

            this.map.addListener('zoom_changed', () => {
                this.bookingStore.zoom = this.map.getZoom()
                this.setDetailsClass()
                this.bookingStore.trigTimeHighlight = true
            })

            this.setCurrentLocation()
        },

        async fetch (force = false) {
            const bounds = this.map.getBounds()

            const topRight = { lat: bounds.getNorthEast().lat(), lng: bounds.getNorthEast().lng() }
            const bottomLeft = { lat: bounds.getSouthWest().lat(), lng: bounds.getSouthWest().lng() }

            this.bookingStore.getMarkers(topRight, bottomLeft, force)
        },

        resetMarkers () {
            for (let i = this.markers.length - 1; i >= 0; i--) {
                this.markers[i].setMap(null)
                this.markers.splice(i, 1)
            }
        },

        async setMarkers (forceReset = false) {
            const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')

            const bounds = this.map.getBounds()

            if (forceReset) {
                this.resetMarkers()
            } else {
                for (let i = this.markers.length - 1; i >= 0; i--) {
                    if (!bounds.contains(this.markers[i].position)) {
                        this.markers[i].setMap(null)
                        this.markers.splice(i, 1)
                    }
                }
            }

            // this.markers = []

            this.clinics.forEach((item) => {
                const clinicsOnAddress = this.clinics.filter(c => c.address.id === item.address.id).length

                item.practitioners.forEach(practitioner => {
                    if (this.markers.find(m => m.title === '' + practitioner.id + '')) {
                        return
                    }

                    let practitionersOnAddress = 0
                    let indexOfPractitioner = 0
                    let loopPractitioners = 0
                    this.clinics.forEach((c) => {
                        if (item.address.id !== c.address.id) {
                            return
                        }
                        c.practitioners.forEach((p, pIndex) => {
                            practitionersOnAddress++
                            loopPractitioners++
                            if (practitioner.id === p.id) {
                                indexOfPractitioner = loopPractitioners
                            }
                        })
                    })

                    // console.log('practitioner =' + practitioner.name)
                    // console.log('practitionersOnAddress = ' + practitionersOnAddress)
                    // console.log('indexOfPractitioner = ' + indexOfPractitioner)

                    // const practitionersOnAddress = this.clinics.filter(c => item.address.id === c.address.id)
                    // const indexOfPractitioner = practitionersOnAddress.findIndex(c => item.id === c.id)

                    let extraClass1 = ''
                    let extraClass2 = ''
                    let zIndex = 0

                    if (practitionersOnAddress === 2 && indexOfPractitioner === 1) {
                        extraClass1 = 'two'
                        extraClass2 = 'two-left'
                        zIndex = 2
                    }
                    if (practitionersOnAddress === 2 && indexOfPractitioner === 2) {
                        extraClass1 = 'two'
                        extraClass2 = 'two-right'
                        zIndex = 1
                    }
                    if (practitionersOnAddress >= 3 && indexOfPractitioner === 1) {
                        extraClass1 = 'three'
                        extraClass2 = 'three-left'
                        zIndex = 2
                    }
                    if (practitionersOnAddress >= 3 && indexOfPractitioner === 2) {
                        extraClass1 = 'three'
                        extraClass2 = 'three-center'
                        zIndex = 3
                    }
                    if (practitionersOnAddress >= 3 && indexOfPractitioner === 3) {
                        extraClass1 = 'three'
                        extraClass2 = 'three-right'
                        zIndex = 1
                    }
                    if (practitionersOnAddress > 3 && indexOfPractitioner > 3) {
                        extraClass1 = 'hidden'
                        extraClass2 = ''
                        zIndex = 0
                    }

                    const marker = new AdvancedMarkerElement({
                        map: this.map,
                        position: { lat: item._geo.lat, lng: item._geo.lng },
                        title: '' + practitioner.id + '',
                        content: this.buildMarker(item, practitioner, extraClass1, extraClass2),
                        zIndex: zIndex
                    })

                    marker.addListener('gmp-click', () => {
                        this.matomoTrackEvent('Booking', 'Open clinic', 'Map')

                        if (clinicsOnAddress > 1) {
                            this.$router.push({ name: 'modal-address', params: { address: item.address.id } })
                        } else {
                            this.$router.push({ name: 'modal-clinic', params: { clinic: item.id } })
                        }
                    })

                    this.markers.push(marker)
                })
            })
        },

        buildMarker (clinic, practitioner, extraClass1, extraClass2) {
            const zoom = this.map.getZoom()
            const content = document.createElement('div')

            let html = '<img class="logotype" src="/images/card/halsoresurs-icon.svg">'

            if (practitioner.marker_url) {
                html += '<img class="image-portrait" src="' + practitioner.marker_url + '">'
            }
            
            if (clinic.survey_score) {
                html += '<div class="marker-tab">'
                html += '<img src="/images/card/review-heart.svg" class="survey-heart">'
                html += '<span>' + clinic.survey_score + '</span>'
                html += '</div>'
            } else if (clinic.is_new === true) {
                html += '<div class="marker-tab new-clinic">NY</div>'
            }
            

            content.classList.add('marker-wrapper')
            if (extraClass1 != '') {
                content.classList.add(extraClass1)
            }
            if (extraClass2 != '') {
                content.classList.add(extraClass2)
            }
            if (zoom > 12) {
                content.classList.add('details')
            }
            content.innerHTML = html

            return content
        },

        setDetailsClass () {
            const zoom = this.map.getZoom()

            if (zoom) {
                // console.log('zoom', zoom)
                this.markers.forEach(marker => {
                    if (zoom <= 12) {
                        // console.log('remove details class')
                        marker.content.classList.remove('details')
                    } else {
                        // console.log('add details class')
                        marker.content.classList.add('details')
                    }
                })
            }
        },

        setCurrentLocation () {
            this.loadingPosition = true

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }

                    this.bookingStore.setCurrentPosition(pos)

                    this.bookingStore.getBounds(pos)

                    this.loadingPosition = false

                    this.bookingStore.trigTimeHighlight = true
                }, () => {
                    this.loadingPosition = false
                })
            } else {
                this.loadingPosition = false
                // Browser doesn't support Geolocation
                // handleLocationError(false, infoWindow, map.getCenter());
            }
        },
        triggerSetCurrentLocation () {
            this.matomoTrackEvent('Booking', 'Position', '')
            this.setCurrentLocation()
        }
    }
}
</script>

<style>
.marker-wrapper {
    width: 44px;
    height: 50px;
    position: relative;
    background-image: url('/images/card/pointer-bg-shadow.png?upd=1');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transition:transform 300ms ease;
    transform-origin: bottom center;

    display: flex;
    justify-content: center;
    align-items: center;

    .logotype {
        width: 14px;
        margin-top: -10px;
        z-index: 2;
    }

    .image-portrait {
        display: none;
        position: absolute;
        z-index: 3;
        top: 4px;
        left: 3px;
        width: 36px;
    }

    .marker-tab {
        display: none;
        position: absolute;
        width: auto;
        z-index: 1;
        top: 12px;
        left: -10px;
        padding: 4px 6px 4px 24px;
        align-items: center;
        background-color: #fff;
        border-radius: 6px;
        font-size: 13px;
        font-weight:500;

        .survey-heart {
            width: 14px;
            margin-right: 3px;
        }
    }

    .marker-tab.new-clinic {
        color:#e09400;
        justify-content: center;
        font-size: 12px;
    }

}

.marker-wrapper.details {
    width: 70px;
    height: 79px;
    border-radius:30px 30px 50px 50px;

    .logotype {
        width: 22px;
        margin-top: -16px;
        z-index: 2;
    }

    .image-portrait {
        display: block;
        top: 8px;
        left: 5px;
        width: 60px;
    }

    .marker-tab {
        display: flex;
        top: 30px;
        left: 35px;
    }

    &.two, &.three
    {
        width: 50px;
        height: 69px;
        background-size: 70px;
        border-radius:40px 40px 100% 100%;

        .image-portrait {
            top: 3px;
            left: -5px;
            width: 60px;
        }

        .marker-tab
        {
            text-align: center;
            justify-content: center;
            width:24px;
            font-size: 12px;
            padding: 4px 3px 14px 3px;

            .survey-heart
            {
                display:none;
            }
        }

    }

    &.two-left {
        transform: rotate(-30deg) translateX(0);

        .marker-tab {
            top: -14px;
            left: auto;
            right:2px;
            transform: scaleX(1) rotate(30deg);
        }
    }

    &.two-right {
        transform: rotate(30deg) translateX(0);

        .marker-tab {
            top: -14px;
            left: 2px;
            right:auto;
            transform: scaleX(1) rotate(-30deg);
        }
    }

    &.three-left {
        transform: rotate(-40deg);

        .marker-tab {
            top: -14px;
            left: auto;
            right:2px;
            transform: scaleX(1) rotate(40deg);
        }

    }
    &.three-center {
        transform: translate(0,1px);

        .marker-tab {
            top: -18px;
            left: auto;
            right:12px;
            transform: scaleX(1);
        }

    }
    &.three-right {
        transform: rotate(40deg);

        .marker-tab {
            top: -14px;
            left: 2px;
            right:auto;
            transform: scaleX(1) rotate(-40deg);
        }
    }
    &.hidden {
        display:none;
    }
}
</style>
